import { api } from 'common';

import { RestApiClassicAuthorizationBlockFormFields } from './FormFields';
import { REST_API_CLASSIC_AUTHORIZATION_DOCUMENTATION_MARKDOWN } from './documentation';
import { type BlockConfigProps } from '../../types';
import { sharedRestBlockDefaultConfig } from '../Rest/Shared/constants';

export const restApiClassicAuthorizationConfig: BlockConfigProps<
  api.FlowDefinition.RestApiClassicAuthorization['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'restApiClassicAuthorization',
  defaultConfig: {
    ...sharedRestBlockDefaultConfig,
    apiInstanceId: '',
  },
  configFields: {
    schema: api.FlowDefinition.RestApiClassicAuthorizationBlockConfigSchema,
    FormFields: RestApiClassicAuthorizationBlockFormFields,
  },
  documentationMarkdown: REST_API_CLASSIC_AUTHORIZATION_DOCUMENTATION_MARKDOWN,
};
